module.exports = __webpack_public_path__ + "static/GminaPuck-0edbd9e557dcfc69c103a8fef73a8ecb.svg";